export const FETCH_CARE_PLAN_AUDIT =
  "app/CARE_PLAN_AUDIT/FETCH_CARE_PLAN_AUDIT";
export const FETCH_CARE_PLAN_AUDIT_SUCCESS =
  "app/CARE_PLAN_AUDIT/FETCH_CARE_PLAN_AUDIT_SUCCESS";
export const FETCH_CARE_PLAN_AUDIT_FAILURE =
  "app/CARE_PLAN_AUDIT/FETCH_CARE_PLAN_AUDIT_FAILURE";
export const RESET_CARE_PLAN_AUDIT =
  "app/CARE_PLAN_AUDIT/RESET_CARE_PLAN_AUDIT";
